import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-section-light pt-24 pb-16 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1e3a5f] font-medium mb-8 hover:opacity-70 transition-opacity">
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>

        <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-2 tracking-tight">Terms of Use</h1>
        <p className="text-[#5a5a5a] text-sm mb-8">Last updated: February 2025</p>

        <div className="space-y-6 text-[#3d3d3d] text-[15px] leading-relaxed">
          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">General information</h2>
            <p>This website is for general information only. It is not professional or legal advice.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">No offer or commitment</h2>
            <p>Nothing on this website constitutes an offer to purchase any business. Any acquisition would be subject to separate, formal agreements.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">Limitation of liability</h2>
            <p>We do not accept liability for decisions made based on this website's content. Seek independent professional advice.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">Governing law</h2>
            <p>These terms are governed by the laws of England and Wales.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
